export default {
    name: 'RefreshSmallSquareFilled',
    dimensions: { width: 22, height: 22 },
    content: `
    <g>
      <rect x="1" y="1" width="20" height="20" rx="2" fill="currentColor" stroke="currentColor" stroke-width="2"/>
      <path d="M17 13C16.1657 15.33 13.8687 17 11.1803 17C7.77082 17 5 14.31 5 11C5 7.69 7.77082 5 11.1803 5C13.8687 5 16.1657 6.67 17 9" stroke="white" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17 5V9H13" stroke="white" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  `
};
